<template>
  <image-box-tool-with-options
    v-if="show"
    ref="menu"
    v-bind="{
      title,
      icon,
      ...$attrs
    }"
  >
    <div
      v-for="(preset, index) in sizePresets.filter(preset => preset.selectable)"
      :key="index"
      class="image-box__option"
      @click="setSizePreset(preset)"
    >
      {{ preset.key }}
    </div>
  </image-box-tool-with-options>
</template>

<script>
import ImageBoxTool from './ImageBoxTool';

export const NORMAL_SIZE = 18;

export default {
  name: 'TextSizeBoxTool',
  extends: ImageBoxTool,
  inheritAttrs: false,
  props: {
    lastFontSize: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      icon: 'text-size',
      title: 'Text Size',
      showLocal: true,
      sizePreset: undefined,
      sizePresets: [
        { key: 'Extra Small', value: 11, selectable: true },
        { key: 'Small', value: 14, selectable: true },
        { key: 'Normal', value: NORMAL_SIZE, selectable: true },
        { key: 'Large', value: 20, selectable: true },
        { key: 'Huge', value: 24, selectable: true },
        { key: 'Custom', value: null, selectable: false },
      ],
      hotkey: 'ctrl+g',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });

    this.sizePreset = this.sizePresets.find((preset) => preset.key === 'Normal');
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = (this.canvas.getActiveObject().get('type') === 'i-text' || this.canvas.getActiveObject().get('type') === 'textbox');
      } else {
        this.showLocal = false;
      }
      this.$emit('changeSubmenuValue', null);
    },
    setSizePreset(preset) {
      this.sizePreset = preset;

      const active = this.canvas.getActiveObject();
      if (active) {
        const fontSize = preset.value || this.lastFontSize || 11;
        active.set({
          scaleX: 1,
          scaleY: 1,
          fontSize,
          styles: [],
        });
      }
      // Closing menu
      this.$refs.menu.close();
      // We need to render the canvas to apply these changes
      this.canvas.renderAll();
      this.$emit('changeSubmenuValue', null);
      this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
    },
  },
};
</script>
